module.exports = __webpack_public_path__ + "static/media/SVG_menu_search_user.30b3c7ed.svg";